import { lazy } from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'

const RootPage = lazy(() => import('modules/complaints/pages/Settings/RootPage'))

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.complaints.path,
      element: <RootPage />,
      handle: {
        meta: () => getSettingPageMeta(navigation, 'complaints'),
      },
    },
  ]
}

export default settingsRoutes
